<div><header><h1>New User</h1><hr></header><UserForm></UserForm></div>